import { useCallback, useEffect, useState } from 'react'
import classNames from 'classnames'

import TitledContainer from 'components/ui/TitledContainer/TitledContainer'
import { ReactComponent as Arrow } from 'images/arrow-up.svg'
import { Warehouse, WarehouseType } from 'services/warehouse-containers/warehouse'
import { WarehouseSearch } from 'components/WarehouseSearch/WarehouseSearch'
import { Button } from 'components/ui/Button/Button'

export type Props = {
  title?: string
  hint?: string
  warehouse: Pick<Warehouse, 'id' | 'name'>
  onSearch: (warehouse: Warehouse) => void
  warehouseTypes?: WarehouseType[]
}

// NOTE: Компонент очень похож на MovementDirection, но непонятно как их объединить.
export const Place = ({
  onSearch,
  warehouse = { id: 0, name: '' },
  title = 'Поиск склада',
  hint = 'Поиск контейнеров на складе',
  warehouseTypes = [WarehouseType.MiniWarehouse],
}: Props) => {
  const [isToogle, setIsToogle] = useState<boolean>(true)
  const [place, setPlace] = useState<Warehouse>(null)

  useEffect(() => {
    setIsToogle(!warehouse.name)
  }, [warehouse.name])

  const renderPlaceholder = useCallback(() => {
    const placeholder = warehouse.name ? warehouse.name : 'Неизвестно'

    const classnameDirection = classNames('direction-short__direction', {
      'direction-short__direction-inactive': !warehouse.name,
    })

    const classnameArrow = classNames('direction-short__arrow', {
      disable: !warehouse.name,
      rotate: isToogle,
    })

    return (
      <div className="direction-short">
        <Arrow onClick={() => setIsToogle((prev) => !prev)} className={classnameArrow} />
        <span>Место проверки:</span>
        <span className={classnameDirection}>{placeholder}</span>
      </div>
    )
  }, [warehouse])

  const handleOnSelect = (ware: Warehouse) => setPlace(ware)

  const handleOnSubmit = () => {
    if (!place) return

    onSearch?.(place)
    setIsToogle(false)
  }

  const classname = classNames('direction__accordion-body', {
    open: isToogle,
  })

  return (
    <TitledContainer title={title} hint={hint}>
      {renderPlaceholder()}
      <div className={classname}>
        <form className="transfer-page-search">
          <span className="transfer-page-search__header">Текущее местоположение:</span>
          <WarehouseSearch onSelect={handleOnSelect} searchForTypes={warehouseTypes} />
        </form>
        <Button disabled={!place} title="Найти" handleOnSubmit={handleOnSubmit}></Button>
      </div>
    </TitledContainer>
  )
}
